import { GLUEUP_LOGO_URL } from "./glueupBrand";

export default function Client() {
  return (
    <div className="client-div">
      <img
        src={GLUEUP_LOGO_URL}
        alt="GlueUp"
        className="glueup-login-logo"
        width={64}
        height={64}
      />
      <h2>Sign in </h2>
      <p>
        to continue to <span> GlueUp</span>
      </p>
    </div>
  );
}
